import { render } from "./VideoCallRoot.vue.js?vue&type=template&id=27d4b4f2&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallRoot.vue?vue&type=template&id=27d4b4f2&scoped=true"
import script from "./VideoCallRoot.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallRoot.vue?vue&type=script&lang=js"
export * from "./VideoCallRoot.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallRoot.vue?vue&type=script&lang=js"

import "./VideoCallRoot.vue.css?vue&type=style&index=0&id=27d4b4f2&scoped=true&lang=css!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallRoot.vue?vue&type=style&index=0&id=27d4b4f2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d4b4f2"],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/VideoCallRoot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27d4b4f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27d4b4f2', __exports__)) {
    api.reload('27d4b4f2', __exports__)
  }
  
  module.hot.accept("./VideoCallRoot.vue.js?vue&type=template&id=27d4b4f2&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallRoot.vue?vue&type=template&id=27d4b4f2&scoped=true", () => {
    api.rerender('27d4b4f2', render)
  })

}


export default __exports__